<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="text">重設密碼</span>
            </v-card-title>
            <v-card-text class="mt-4">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent="submit"
                >
                    <template v-for="(field, i) in fields">
                        <v-text-field
                            v-if="['text', 'password'].includes(field.type)"
                            :key="i"
                            :type="field.type"
                            v-model="form[field.key]"
                            :label="field.name"
                            :rules="field.rules"
                            outlined
                        ></v-text-field>
                    </template>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="submit"
                    :loading="loading"
                    >確定</v-btn
                >
                <v-btn
                    color="grey darken-3"
                    text
                    @click="close"
                    :disabled="loading"
                    >取消</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        fields: Array,
        handleSubmit: Function,
    },
    data: () => ({
        dialog: false,
        loading: false,
        valid: true,
        form: {
        },
    }),
    methods: {
        initForm() {
            if (this.$refs.form) this.$refs.form.reset();
            this.loading = false;
        },
        show(payload) {
            this.initForm();
            this.dialog = true;
            this.payload = payload;
        },
        close() {
            this.dialog = false;
        },
        async submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                try {
                    await this.handleSubmit({ data: this.form, payload: this.payload });
                    this.close();
                } catch (e) {
                    this.$showApiError(e);
                } finally {
                    this.loading = false;
                }
            }
        },
    },
};
</script>

<style>
</style>
